import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../../../helpers/number'

const OrderItemQuantity = ({orderItem, quantity, ...props}) => {
    const [t] = useTranslation()

    const getUnit = () => {
        if (!orderItem.sellableUnit || orderItem.sellableUnit.type === 'COUNT') {
            return null
        }

        return t(`order.detail.sellable_unit.${orderItem.sellableUnit.type}.unit.${orderItem.sellableUnit.unit}`)
    }

    return (
      <span className={props.className}>
          {formatNumber(quantity)}&nbsp;{getUnit()}
      </span>
    )
}

export { OrderItemQuantity }
